import * as React from 'react';
import {isLoggedIn} from '../../../../../data/user.model';
import { isEcommerceEnabled } from '../../../../../selectors/generic';
import {useI18N} from "../../../../my-puratos/hoc/withI18N";
import {useDispatch} from "react-redux";
import {redirectToLogin} from "../../../../../actions/auth";
import {ProductContext} from "../../../../pages/ProductStencil";
import { useContext } from 'react';
import { NoEcommerce } from '../NoEcommerce/NoEcommerce';

export function RichTextCTA() {

    if(!isEcommerceEnabled()) {
        return <NoEcommerce />;
    }
    
    if (isLoggedIn()) {
        return null;
    }

    const translate = useI18N();
    const dispatch = useDispatch();
    const {stencil, signInOrCreateAccount} = useContext(ProductContext);

    return (
        <div className="sign-in">
            <div className="sign-in__buttons">
                <button className="btn btn-primary" onClick={() => dispatch(redirectToLogin())}>
                    {translate("Sign in to view prices")}
                </button>
                <button className="btn btn-secondary" onClick={() => window.location.href = stencil.signUpUrl}>
                    {translate("Create an account")}
                </button>
            </div>
            <div className="benefits" dangerouslySetInnerHTML={{ __html: signInOrCreateAccount.text }} />
        </div>
    );
}
